angular.module('impactx.cscontract').controller('DeviationVisualCtrl', ['$scope', DeviationVisualCtrl]);

function DeviationVisualCtrl($scope)
{
    $scope.minDev = 0;
    $scope.maxDev = 0;
    
    if(!$scope.valuePow){
        $scope.valuePow = 0;
    }
    
    $scope.$watch(function(){
        return Number($scope.baseValue);
    }, function(newVal, oldVal) { 
        if((newVal || newVal === 0) && newVal !== oldVal){
            setMinMaxBase();
        }
    });
    $scope.$watch(function(){
        return Number($scope.modelMin);
    }, function(newVal, oldVal){
        if((newVal || newVal === 0) && newVal !== oldVal) {
            setMinMaxBase();
        }
    });
    $scope.$watch(function(){
        return Number($scope.modelMax);
    }, function(newVal, oldVal){
        if((newVal || newVal === 0) && newVal !== oldVal) {
            setMinMaxBase();
        }
    });
    
    $scope.getPow = function(){
        return Math.pow(10, $scope.valuePow);
    };
    
    var setMinMaxBase = function(){
        if ($scope.fixedDeviation) {
            $scope.deviation = Number($scope.fixedDeviation);
            $scope.baseValue = 0;
        }
        else {
            var checkValue;
            if ($scope.minDeviation) {
                checkValue = Number($scope.minDeviation);
            }  else {
                checkValue = (Number($scope.modelMax) > Number($scope.modelMin) ? Number($scope.modelMax) : Number($scope.modelMin));
            }
            var currentPow = Math.pow(10, Number($scope.valuePow)+1);
            for(var pow = 0; checkValue/currentPow>10 && pow < 8; pow++){
                currentPow = currentPow * 10;
            }
            var maxDev = currentPow;
            for(var mult = 1; checkValue>maxDev && mult < 10; mult++){
                maxDev += currentPow;
            }
            $scope.deviation = maxDev;
        }
    };
    
    $scope.getJoinStyle = function(value, direction){
        var base = Number($scope.baseValue);
        var style = {};
        var opp = direction === "left" ? "right" : "left";
        value = Number(value);
        if(!(value||value===0)){
            style[direction] = '';
        } else if(value<=$scope.deviation) {
            var valDir;
            if(direction === 'left'){
                valDir = 50+((base-value)/2/$scope.deviation*100);
            } else {
                valDir = 50-((base+value)/2/$scope.deviation*100);
            }
            style[direction] = valDir+'%';
        } else {
            style[direction] = '-1px';
            style['background'] = '#DD2C00';
        }
        var valOpp;
        if(direction === 'left'){
            valOpp = 50-(base/2/$scope.deviation*100);
        } else {
            valOpp = 50+(base/2/$scope.deviation*100);
        }
        style[opp] = valOpp+'%';
        return style;
    };
    
    $scope.getBaseValueStyle = function(){
        var base = Number($scope.baseValue);
        return {
            left: (50+(base/2/$scope.deviation*100))+'%',
            right: (50-(base/2/$scope.deviation*100))+'%',
            position: 'absolute',
            zIndex: 3
        };
    };
    
    $scope.getBaseLabelStyle = function(){
        var base = Number($scope.baseValue);
        var offset = base/2/$scope.deviation*100;
        if(offset < 1.4){
            offset = 1.4;
        }
        return {left: 50 + offset + '%'};
    };
    
    $scope.getLabelStyle = function(value, direction){
        var baseVal = Number($scope.baseValue);
        var style = {};
        var opp = direction === "left" ? "right" : "left";
        value = Number(value);
        if(!(value||value===0) || value>=$scope.deviation){
            style[direction] = '0';
        } else {
            var valDir, base;
            if(direction === 'left'){
                valDir = 50+((baseVal-value)/2/$scope.deviation*100);
                base = 50-(baseVal/2/$scope.deviation*100);
            } else {
                valDir = 50-((baseVal+value)/2/$scope.deviation*100);
                base = 50+(baseVal/2/$scope.deviation*100);
            }
            if(100-valDir-base < 5){
                style[opp] = base+'%';
            } else {
                style[direction] = valDir+'%';
            }
        }
        return style;
    };
    
    $scope.getLabelValue = function(value, isMin){
        if(value||Number(value)===0){
            if(isMin){
                return ((Number($scope.baseValue)-Number(value))/$scope.getPow())+" "+$scope.postFix
            }
            return ((Number($scope.baseValue)+Number(value))/$scope.getPow())+" "+$scope.postFix
        }
        return $scope.noValueLabel;
    };
    
    setMinMaxBase();
}